exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".income-log-table-container[data-v-a93bf6ae] {\n  margin: 20px 0;\n}\n.pagination-container[data-v-a93bf6ae] {\n  margin-top: 20px;\n}\n", ""]);

// exports
